<template>
	<div>
		<a v-if="list?.length" @click="openDialog">查看</a>
		<el-dialog title="特殊入库要求" :visible.sync="dialogVisible" width="1000px" :footer="null"
			custom-class="special-stock-title-modal">
			<div class="title">
				本次入库商品规格：
				<span v-html="item.productProp?.replace(/:([^;]+)/g, ':<b>$1</b>')"></span>
			</div>
			<WmsTable :columns="columns" :dataSource="list" :isPagination="false" :filterSoltHeader="true">
        <template #productTitle="{ text, record }">
          <el-tooltip class="item" effect="dark" :content="text" placement="top">
            <div class="line--2">{{ text }}</div>
          </el-tooltip>
        </template>
				<template #customerShopName="{ text, record }">
					<div>
						<p>{{ text }}</p>
						<el-tag type="danger" v-if="item.celebritiesFlag">网红店铺</el-tag>
					</div>
				</template>
				<template #sizePick="{ text, record }">
					<a @click="openSizeModal(record.measureContentDtoList)" v-if="record.measureContentDtoList?.length">查看</a>
					<span v-else>-</span>
				</template>
				<template #specialInboundRequirementImgList="{ text }">
					<el-image :src="replaceWidth(item.url)" alt="" v-for="item in text" :key="item.url"
						style="margin: 0 4px 4px 0; width: 40px; height: 40px" :preview-src-list="text.map((v) => v.url)" />
				</template>
				<template #productPropertiesName="{ text }">
					<span v-html="text?.replace(/:([^;]+)/g, ':<b>$1</b>') ?? '-'" class="props-style"></span>
				</template>
			</WmsTable>
			<template #footer></template>
		</el-dialog>
		<el-dialog title="尺寸对比" :visible.sync="sizeVisible" width="1000px" :footer="null">
			<el-descriptions title="" :column="2" border :labelStyle="{ width: '250px' }">
				<el-descriptions-item v-for="(item, index) in productMeasureDtoList" :key="index">
					<template slot="label">
						<span style="font-size: 14px">{{ item.name }}</span>
					</template>
					<span style="font-size: 14px">{{ item.value }}</span>
				</el-descriptions-item>
			</el-descriptions>
			<template #footer></template>
		</el-dialog>
	</div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
export default {
	name: "special-stock",
	props: ["item", "list"],
	components: {
		WmsTable,
	},
	data() {
		return {
			dialogVisible: false,
			sizeVisible: false,
			dataSource: [],
			columns: [
				{
					title: "店铺名称",
					dataIndex: "customerShopName",
					key: "customerShopName",
					width: 100,
					scopedSlots: {
						customRender: "customerShopName",
					},
				},
				{
					title: "客户编号",
					dataIndex: "customerId",
					key: "customerId",
					width: 100,
				},
        {
          title: "商品名称",
          dataIndex: "productTitle",
          key: "productTitle",
          scopedSlots: {
            customRender: "productTitle",
          },
        },
				{
					title: "商品规格",
					dataIndex: "productPropertiesName",
					key: "productPropertiesName",
					scopedSlots: {
						customRender: "productPropertiesName",
					},
				},
				{
					title: "特殊入库要求",
					dataIndex: "specialInboundRequirement",
					key: "specialInboundRequirement",
					width: 120,
				},
				{
					title: "图片",
					dataIndex: "specialInboundRequirementImgList",
					key: "specialInboundRequirementImgList",
					width: 120,
					scopedSlots: {
						customRender: "specialInboundRequirementImgList",
					},
				},
				{
					title: "尺寸",
					dataIndex: "sizePick",
					key: "sizePick",
					width: 100,
					scopedSlots: {
						customRender: "sizePick",
					},
				},
			],
			productMeasureDtoList: [],
		};
	},
	methods: {
		replaceWidth(str = "") {
			return str.replace(/width=\d+/, "width=100");
		},
		openDialog() {
			this.dialogVisible = true;
		},
		openSizeModal(productMeasureDtoList) {
			this.productMeasureDtoList = productMeasureDtoList;
			this.sizeVisible = true;
		},
	},
};
</script>
<style lang="less">
.special-stock-title-modal {
	.title {
		font-weight: bold;
		font-size: 26px;

		b {
			color: red;
			font-size: 30px;
		}
	}

	.props-style {
		b {
			color: red;
			font-weight: bold;
			font-size: 20px;
		}
	}
}
</style>
